// 3rd Party
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

// Components
import { Div, FlexRow, H3, P } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';
import {
  DIMENSIONS,
  useWindowDimensions,
} from 'providers/WindowDimensionsProvider';

import {
  selectDataCheckoutFormData,
  selectDataPatient,
} from '../../../../../connect/selectors';
import { StyledTextArea } from '../../../checkout-styled-components';
import { makeSelectRequestData } from '../../../connect/selectors';
import { contactPreferences } from '../../../helpers/checkout-constants';
import { formatPhoneNumber } from '../../../helpers/confirmation-helpers';

import { CommunicationCheckboxes } from './styled-components';

// Others

const ContactDetailsCard = ({ setNotes, state }) => {
  const patient = useSelector(selectDataPatient);
  const checkoutData = useSelector(selectDataCheckoutFormData);
  const contactDetails = state || patient || checkoutData;
  const [showPhoneNumber, setShowPhoneNumber] = useState(false);
  const requestData = useSelector(makeSelectRequestData);
  const { layout } = useWindowDimensions();

  useEffect(() => {
    requestData.contactMethods = [];
  }, []);

  useEffect(() => {
    if (contactDetails.mobilePhone) {
      setShowPhoneNumber(true);
    }
  }, [contactDetails]);

  const handleCommunicationChange = e => {
    requestData.contactMethods = e;
  };

  return (
    <Div
      margin={`${
        layout === DIMENSIONS.MOBILE ? ' -.25em 0 10px' : '0 0 10px 0'
      }`}
      aria-label="Contact Details"
    >
      <FlexRow
        margin={`${layout === DIMENSIONS.MOBILE ? '0 0 -1em' : ''}`}
        width="100%"
      >
        {contactDetails 
          && (
            <div>
              <H3 className="sensitive-data" margin="0" fontSize="20px">{`${
                contactDetails.firstName
              } ${contactDetails.lastName}`}
              </H3>
              <P className="sensitive-data" color={colors.slate}>
                {contactDetails.email}
              </P>
              {showPhoneNumber 
                && (
                  <P className="sensitive-data" color={colors.slate}>
                    {formatPhoneNumber(contactDetails.mobilePhone)}
                  </P>
                )
              }
              <P margin="5px 0 -10px" fontWeight="bold">
                I prefer to be contacted via:
              </P>
              <FlexRow justify="space-between" margin="10px 0 0" flexWrap="wrap">
                <CommunicationCheckboxes
                  className="sensitive-data"
                  onChange={e => handleCommunicationChange(e)}
                  options={contactPreferences}
                />
              </FlexRow>
            </div>
          )
        }
      </FlexRow>
      <br />
      <StyledTextArea
        className="sensitive-data"
        rows={`${layout === DIMENSIONS.MOBILE ? 2 : 4}`}
        placeholder="Notes for the practice"
        onChange={({ target: { value } }) => {
          setNotes(value);
        }}
      />
    </Div>
  );
};

ContactDetailsCard.propTypes = {
  setNotes: PropTypes.func,
  state: PropTypes.object,
};
export default ContactDetailsCard;
